export default __webpack_public_path__ + "static/media/vegetable.f0ed4b61.webp";